import api from '../js/api';
import toast from '../common/toast';
import pop from '../common/pop';
export default {
  name: 'emailForget',
  props: {
    loginName: {
      type: String,
      default: ''
    },
    wayType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      has: false,
      toastState: false,
      cover: false,
      txt: '',
      poptxt: ''
    };
  },
  components: {
    'toast-pop': toast,
    'pop-pop': pop
  },
  methods: {
    selectWay: function selectWay(type, first) {
      this.$emit('selectWay', type, first);
    },
    send: function send() {
      var _this = this;
      this.cover = true;
      api.sendEmail(this.loginName, 3, '').then(function (data) {
        _this.cover = false;
        if (data.ret === '1') {
          _this.has = true;
          _this.poptxt = _this.$t(_this.$loginLangPrefix('userSign.hasSend'));
        } else {
          _this.showPop(_this.$t(_this.$loginLangPrefix('userSign.sysError')));
        }
      }).catch(function (response) {
        _this.cover = false;
        if (response.errorMessageTMXTip) {
          return;
        }
        _this.showPop(_this.$t(_this.$loginLangPrefix('userSign.sysError')));
      });
    },
    sure: function sure() {
      this.selectWay(this.wayType);
    },
    clickPopHandle: function clickPopHandle() {
      this.has = false;
      this.selectWay(this.wayType, true);
    },
    showPop: function showPop(txt, callback) {
      var _this2 = this;
      this.txt = txt;
      this.toastState = true;
      setTimeout(function () {
        _this2.txt = '';
        _this2.toastState = false;
        callback && callback();
      }, 1500);
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};